<template>
    <v-container fluid>        
        <fulldialog-usuario v-if="dialog"/>
        <fulldialog-grupo v-if="dialogGrupo"/>
        <fulldialog-tipousuario v-if="dialogTipoUsuario"/>
        <div v-if="!dialog && !dialogGrupo && !dialogTipoUsuario">
            <div class="text-h4 mb-5 mt-5">Usuarios</div>
            <v-card :loading="loadingUsuarios">
                <v-card-title>
                    <v-text-field
                        v-model="buscarUsuarios"
                        append-icon="mdi-account-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headersUsuarios"
                    :items="usuarios"
                    :search="buscarUsuarios"
                >
                    <template v-slot:item.estado="{ item }">
                        <v-chip
                            :color="getColorEstado(item.estado)"
                            outlined
                            pill
                            small
                        >
                            {{ item.estado }}
                        </v-chip>
                    </template>
                    <template v-slot:item.fechaCreacion="{ item }">
                            {{ formatearFecha(item.fechaCreacion) }}
                    </template>
                    <template v-slot:item.acciones="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="editarUsuario(item)"
                        >
                            mdi-account-edit-outline
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
            <div class="text-h4 mb-5 mt-5">Grupos</div>
            <v-card :loading="loadingGrupos">
                <v-card-title>
                    <v-text-field
                        v-model="buscarGrupos"
                        append-icon="mdi-account-multiple-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headersGrupos"
                    :items="grupos"
                    :search="buscarGrupos"
                >
                    <template v-slot:item.estado="{ item }">
                        <v-chip
                            :color="getColorEstado(item.estado)"
                            outlined
                            pill
                            small
                        >
                            {{ item.estado }}
                        </v-chip>
                    </template>
                    <template v-slot:item.fechaCreacion="{ item }">
                            {{ formatearFecha(item.fechaCreacion) }}
                    </template>
                    <template v-slot:item.acciones="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="editarGrupo(item)"
                        >
                            mdi-shield-edit-outline
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
            <div class="text-h4 mb-5 mt-5">Tipos de usuario</div>
            <v-card :loading="loadingTiposUsuarios">
                <v-card-title>
                    <v-text-field
                        v-model="buscarTiposUsuario"
                        append-icon="mdi-account-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headersTiposUsuario"
                    :items="tiposUsuarios"
                    :search="buscarTiposUsuario"
                >
                    <template v-slot:item.estado="{ item }">
                        <v-chip
                            :color="getColorEstado(item.estado)"
                            outlined
                            pill
                            small
                        >
                            {{ item.estado }}
                        </v-chip>
                    </template>
                    <template v-slot:item.created_at="{ item }">
                            {{ formatearFecha(item.created_at) }}
                    </template>
                    <template v-slot:item.acciones="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="editarTipoUsuario(item)"
                        >
                            mdi-account-edit-outline
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <v-speed-dial
            v-model="fab"
            fixed
            direction="top"
            :transition="transition"
            style="bottom: 37px; right: 30px;"
        >
            <template v-slot:activator>
                <v-btn
                v-model="fab"
                color="teal lighten-1"
                dark
                fab
                >
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
            </template>
            
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        fab
                        dark
                        small
                        color="green"
                        @click="nuevoUsuario()"
                    >
                        <v-icon>mdi-account-plus-outline</v-icon>
                    </v-btn>
                </template>
                <span>Nuevo usuario</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        fab
                        dark
                        small
                        color="indigo"
                        @click="nuevoGrupo()"
                    >
                        <v-icon>mdi-account-multiple-plus-outline</v-icon>
                    </v-btn>
                </template>
                <span>Nuevo grupo</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        fab
                        dark
                        small
                        color="blue-grey"
                        @click="nuevoTipoUsuario()"
                    >
                        <v-icon>mdi-account-settings-outline</v-icon>
                    </v-btn>
                </template>
                <span>Nuevo tipo de usuario</span>
            </v-tooltip>
        </v-speed-dial> 
    </v-container>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import formatearFecha from '../../mixins/formatearFecha'
    import FullDialogUsuario from './FullDialogUsuario';
    import FullDialogGrupo from './FullDialogGrupo';
    import FullDialogTipoUsuario from './FullDialogTipoUsuario';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'Usuarios',
        mixins: [formatearFecha],
        data: () => ({
            fab: false,
            transition: 'slide-y-reverse-transition',
            buscarUsuarios: '',
            buscarGrupos: '',
            buscarTiposUsuario: '',
            headersUsuarios: [
                {
                    text: 'Nombre',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: 'Apellidos',
                    filterable: true,
                    sortable: true,
                    value: 'apellidos',
                },
                {
                    text: 'Email',
                    filterable: true,
                    sortable: true,
                    value: 'email'
                },
                {
                    text: 'Fecha creación',
                    filterable: false,
                    sortable: false,
                    value: 'fechaCreacion'
                },
                {
                    text: 'Estado',
                    filterable: true,
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: '',
                    filterable: false,
                    sortable: false,
                    value: 'acciones'
                }
            ],
            headersGrupos: [
                {
                    text: 'Nombre',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: 'Fecha creación',
                    filterable: false,
                    sortable: false,
                    value: 'fechaCreacion',
                },
                {
                    text: 'Estado',
                    filterable: true,
                    sortable: true,
                    value: 'estado',
                },
                {
                    text: '',
                    filterable: false,
                    sortable: false,
                    value: 'acciones'
                }
            ],
            headersTiposUsuario: [
                {
                    text: 'Nombre',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: 'Fecha creación',
                    filterable: false,
                    sortable: false,
                    value: 'created_at',
                },
                {
                    text: 'Estado',
                    filterable: true,
                    sortable: true,
                    value: 'estado',
                },
                {
                    text: '',
                    filterable: false,
                    sortable: false,
                    value: 'acciones'
                }
            ],
            loadingUsuarios: false,
            loadingGrupos: false,
            loadingTiposUsuarios: false,
            horario: [
                {
                    dia:'lunes',
                    entradaManana:'09:00',
                    salidaManana:'14:00',
                    entradaTarde:'15:00',
                    salidaTarde:'18:30'
                },
                {
                    dia:'martes',
                    entradaManana:'09:00',
                    salidaManana:'14:00',
                    entradaTarde:'15:00',
                    salidaTarde:'18:30'
                },
                {
                    dia:'miercoles',
                    entradaManana:'09:00',
                    salidaManana:'14:00',
                    entradaTarde:'15:00',
                    salidaTarde:'18:30'
                },
                {
                    dia:'jueves',
                    entradaManana:'09:00',
                    salidaManana:'14:00',
                    entradaTarde:'15:00',
                    salidaTarde:'18:30'
                },
                {
                    dia:'viernes',
                    entradaManana:'09:00',
                    salidaManana:'15:00',
                    entradaTarde:'',
                    salidaTarde:''
                }
            ],
        }),
        methods: {
            ...mapActions('usuarios', { setDialogUsuario: 'setDialog', setUsuario:'setUsuario', setUsuarios:'setUsuarios', setNuevoUsuario:'setNuevoUsuario', setGruposUsuario:'setGruposUsuario'}), // Mapeo las acciones y las identifico con nombres distintos para que no se pisen las acciones setDialog de usuarios y grupos
            ...mapActions('grupos', { setDialogGrupo: 'setDialog', setDialogNuevoGrupo: 'setDialogNuevoGrupo', setGrupos:'setGrupos', setGrupo:'setGrupo', setNuevoGrupo: 'setNuevoGrupo'}),
            ...mapActions('tipoUsuario', {setDialogTipoUsuario: 'setDialog', setTiposUsuarios: 'setTiposUsuarios', setTipoUsuario: 'setTipoUsuario', setNuevoTipoUsuario: 'setNuevoTipoUsuario'}),
            ...mapActions('horario', ['setHorario']),
            ...mapActions('estado', ['setEstado']),
            ...mapActions('equipos', ['setEquipos']),
            ...mapActions('componentes', ['setPermisos', 'setComponentes']),
            ...mapActions(['setLoading', 'setSnackbar']),
            async editarUsuario(item){
                this.setLoading(true);
                try {
                    let respuesta = await axios.get("/api/tipousuario");
                    this.setTipoUsuario(respuesta.data);
                    
                    respuesta = await axios.get("/api/grupos");
                    this.setGruposUsuario(respuesta.data);
                        
                    respuesta = await axios.get("/api/usuarios/"+item.email);
                    this.setUsuario(respuesta.data);
                        
                    respuesta = await axios.get(`/api/horarios/${this.usuario.id}`);
                    this.setHorario(respuesta.data);
                    
                    respuesta = await axios.get(`/api/estadoUsuario?usuario=${this.usuario.id}`);
                    this.setEstado(respuesta.data);

                    respuesta = await axios.get('/api/equipos');
                    this.setEquipos(respuesta.data);

                    this.setLoading(false);
                    this.setDialogUsuario(true);
                } catch (error) {
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido recuperar los datos'
                    });
                } 
            },
            async editarGrupo(item){
                this.setLoading(true);
                try{
                    let respuesta;
                    if(this.permisos.length === 0){ // No se han cargado los permisos de la aplicación
                        console.log('No se han cargado los permisos, los recuperamos');
                        respuesta = await axios.get("/api/permisos");
                        console.log(respuesta.data);
                        this.setPermisos(respuesta.data);
                    }
                    if(this.componentes.length === 0){ // No se han cargado los componentes de la aplicación
                        console.log('No se han cargado los componentes, los recuperamos');
                        respuesta = await axios.get("/api/componentes");
                        console.log(respuesta.data);
                        this.setComponentes(respuesta.data);
                    }
                    respuesta = await axios.get("/api/grupos/"+item.id);
                    console.log(respuesta.data);
                    this.setGrupo(respuesta.data);
                    this.setLoading(false);
                    this.setDialogGrupo(true);
                }catch(error){
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'No se ha podido recuperar la información del grupo'
                    });
                }
                // axios.get("/api/grupos/"+item.id).then(respuesta => {
                //         this.setLoading(false);
                //         this.setGrupo(respuesta.data);
                //         this.setDialogGrupo(true);
                //         console.log(respuesta.data);
                //     }).catch(error =>{
                //         console.log(error);
                //         this.setLoading(false);
                //         this.setSnackbar({
                //             snackbar: true,
                //             tipo: 'error',
                //             mensaje: 'No se ha podido recuperar la información del grupo'
                //         });
                //     });
            },
            editarTipoUsuario(item){
                this.setLoading(true);
                axios.get("/api/tipousuario/"+item.id).then(respuesta => {
                    this.setLoading(false);
                    console.log(respuesta.data);
                    this.setTipoUsuario(respuesta.data);
                    this.setDialogTipoUsuario(true);
                }).catch(error => {
                    console.log(error);
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'No se ha podido recuperar la información del tipo de usuario'
                    });
                });
            },
            getColorEstado(estado){
                return estado == 'Habilitado' ? 'success' : 'default'
            },
            async nuevoUsuario(){
                this.setLoading(true);
                try {
                    let respuesta = await axios.get("/api/grupos");
                    this.setGruposUsuario(respuesta.data);
                        
                    respuesta = await axios.get("/api/tipousuario");
                    this.setTipoUsuario(respuesta.data);
                    this.setNuevoUsuario();
                    
                    respuesta = await axios.get('/api/equipos');
                    this.setEquipos(respuesta.data);

                    this.setHorario(this.horario);
                    this.setEstado({mensaje:'', ocupado:false});

                    this.setLoading(false);
                    this.setDialogUsuario(true);
                } catch (error) {
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido recuperar los datos'
                    });
                }
            },
            async nuevoGrupo(){
                this.setLoading(true);
                try{
                    let respuesta;
                    if(this.permisos.length === 0){ // No se han cargado los permisos de la aplicación
                        console.log('No se han cargado los permisos, los recuperamos');
                        respuesta = await axios.get("/api/permisos");
                        console.log(respuesta.data);
                        this.setPermisos(respuesta.data);
                    }
                    if(this.componentes.length === 0){ // No se han cargado los componentes de la aplicación
                        console.log('No se han cargado los componentes, los recuperamos');
                        respuesta = await axios.get("/api/componentes");
                        console.log(respuesta.data);
                        this.setComponentes(respuesta.data);
                    }
                    this.setLoading(false);
                    this.setNuevoGrupo();
                    this.setDialogGrupo(true);
                }catch (error){
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'No se ha podido recuperar la información del grupo'
                    });
                }
                // axios.get("/api/permisos").then(respuesta => {
                //     let permisos = respuesta.data;
                //         this.setLoading(false);
                //         this.setNuevoGrupo(permisos);
                //         this.setDialogGrupo(true);
                // }).catch(error => {
                //     this.setLoading(false);
                //     // console.log(error);
                //     this.setSnackbar({
                //         snackbar: true,
                //         tipo: 'error',
                //         mensaje: 'No se han podido recuperar los permisos del grupo'
                //     });
                // });
            },
            nuevoTipoUsuario(){
                console.log("Ventana nuevo tipo usuario");
                this.setNuevoTipoUsuario();
            },
        },
        mounted() {
            this.loadingUsuarios = true;
            axios.get("/api/usuarios").then(respuesta => {
                this.setUsuarios(respuesta);
                this.loadingUsuarios = false;
            }).catch(error =>{
                console.log(error);
                this.loadingUsuarios = false;
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'No se han podido recuperar los usuarios'
                });
            });

            this.loadingGrupos = true;
            axios.get("/api/grupos").then(respuesta => {
                //console.log(respuesta);
                this.setGrupos(respuesta);
                this.loadingGrupos = false;
            }).catch(error =>{
                this.loadingGrupos = false;
                console.log(error);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'No se han podido recuperar los grupos'
                });
            });

            this.loadingTiposUsuarios = true;
            axios.get("/api/tipousuario").then(respuesta => {
                this.loadingTiposUsuarios = false;
                this.setTiposUsuarios(respuesta.data);
            }).catch(error =>{
                this.loadingTiposUsuarios = false;
                console.log(error);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'No se han podido recuperar los tipos de usuario'
                });
            });
        },
        computed: {
            ...mapState('usuarios', ['usuarios','usuario' , 'dialog']),
            ...mapState('grupos', {grupos: 'grupos', dialogGrupo: 'dialog'}),
            ...mapState('componentes', ['permisos', 'componentes']),
            ...mapState('tipoUsuario', {dialogTipoUsuario: 'dialog', tiposUsuarios: 'tiposUsuarios'})
        },
        components: {
            'fulldialog-usuario': FullDialogUsuario,
            'fulldialog-grupo': FullDialogGrupo,
            'fulldialog-tipousuario': FullDialogTipoUsuario,
        }
    }
</script>